import { omitBy } from 'lodash'

const responseMsgStatus = (
  state = {},
  { type: stringType, field, error: { fieldErrors = [] } = {}, messages = [] }
) => {
  const shouldCompute = fieldErrors.length || messages.length
  let [, type, status = ''] = stringType.match(/(.+?)_?(ERROR|SUCCESS)?$/)

  if (!status) {
    return omitBy(state, key => type == state[key]?.type || field == key)
  }

  if (!shouldCompute) return state

  const fields = { ...state };

  (fieldErrors.length ? fieldErrors : messages).forEach(
    e => (fields[field || e.field] = { type, status, message: e.message || e })
  )

  return fields
}

export default responseMsgStatus
